import { CellPreviewCard } from '@renderer/overlay/Sidepanel/components/cell-preview-card'
import { SectionLabel } from '../components/section-label'
import { LinkPill } from '../components/link-pill'
import { BriefLinkPreviewCard } from '../components/brief-link-preview'
import { normalizeBriefLinkUrl } from '../link-previews'
import type { BriefLink, BriefLinkPreview } from '../types'

interface BriefLinksSectionProps {
  links: Array<BriefLink>
  /** v2 provenance keyed by normalized link URL. A link with no entry stays a plain pill. */
  previews?: Record<string, BriefLinkPreview>
}

export function BriefLinksSection({ links, previews }: BriefLinksSectionProps) {
  if (links.length === 0) return null
  return (
    <div className="flex w-full flex-col gap-1.5">
      <SectionLabel>Relevant Links</SectionLabel>
      <div className="flex flex-col items-start gap-1">
        {links.map((link) => {
          const preview = previews?.[normalizeBriefLinkUrl(link.url)]
          if (!preview) {
            return <LinkPill key={link.url} link={link} />
          }
          return (
            // w-auto: the card's trigger is a full-width block by default, which
            // would stretch the pill across the column it sits at the start of.
            <CellPreviewCard
              key={link.url}
              triggerClassName="w-auto max-w-full"
              popupClassName="w-[320px] max-w-[320px]"
              density="tight"
              preview={<BriefLinkPreviewCard link={link} preview={preview} />}
            >
              <LinkPill link={link} />
            </CellPreviewCard>
          )
        })}
      </div>
    </div>
  )
}
